import { Input as ChakraInput, InputProps as ChakraInputProps } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

import { forwardRef } from '../../system';

import InputMask, { maskPropTypes } from './_InputMask';
import { DisplayNames } from './enums';

export const variantPropTypes = ['basic', 'outline', 'filled', 'ghost', 'unstyled'];
export const sizePropTypes = ['xs', 'sm', 'md', 'lg'];

export const fieldPropTypes = {
  size: PropTypes.oneOf(sizePropTypes),
  isDisabled: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  isInvalid: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  isRequired: PropTypes.bool
};

const propTypes = {
  ...fieldPropTypes,
  variant: PropTypes.oneOf(variantPropTypes),
  mask: PropTypes.oneOf(maskPropTypes),
  getInputRef: PropTypes.func
};

export const defaultProps = {
  variant: 'basic',
  size: 'md'
};

export type InputProps = ChakraInputProps & {
  mask?: string;
  customOptions?: Record<string, unknown>;
  getInputRef?: (element: HTMLInputElement) => void;
};

const Input = forwardRef<InputProps, 'input'>(
  (props: InputProps & typeof defaultProps, ref): React.ReactElement => {
    const { mask, customOptions, ...rest } = props;

    return mask ? (
      <ChakraInput as={InputMask} customOptions={customOptions} mask={mask} ref={ref} {...rest} />
    ) : (
      <ChakraInput ref={ref} {...props} />
    );
  }
);

Input.propTypes = propTypes;
Input.defaultProps = defaultProps;
Input.displayName = DisplayNames.Input;

export default Input;
